import React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

export default createSvgIcon(
  <path fill="currentColor" fillRule="evenodd" d="M2 12v10h5v-1.6384l-1.67-.0107-1.6702-.0107-.0105-2.9201L3.6388 14.5h5.0415v.8197h1.6394v-2.5H3.6803V3.6803h9.1394v2.459H12v1.6804h2.5V3.6388l2.9201.0105 2.9201.0105.0107 1.6701L20.3616 7h-2.5009v1.6803h2.5v4.1394H14.5V10.318l-.8299.0111-.8299.0111-.0104 5.0102-.0105 5.0103H9.5V22h5v-7.5H22V2H2z" clipRule="evenodd" />
, 'DisplayFloorPlanOutlinedx');
